<template>
  <Accessory
    idname="保理客户资料"
    fileMenuUrlname=""
    :projectid="$route.params.id"
    :bankid="$route.params.id"
    :upload="!readOnly"
  />
</template>
<script>
import Accessory from "@/components/accessories/accessory";
export default {
  name: "accessory",
  data() {
    return {
      id: "",
    };
  },
  components: {
    Accessory,
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
